import {
  IconChecklist,
  IconLayoutDashboard,
  IconManualGearbox,
  IconNotification,
  IconPalette,
  IconReport,
  IconReportMoney,
  IconSettings,
  IconTool,
  IconUserCog,
  IconUserShield,
} from "@tabler/icons-react";
import { BugIcon } from "lucide-react";
import { type SidebarData } from "../types";
import { GearIcon } from "@radix-ui/react-icons";

export const adminSidebarData: SidebarData = {
  user: {
    name: "admin",
    email: "admindev@cao.ac.za",
    avatar: "/avatars/shadcn.jpg",
  },

  navGroups: [
    {
      title: "General",
      items: [
        {
          title: "Home",
          url: "/",
          icon: IconLayoutDashboard,
        },
      ],
    },
    {
      title: "Maintenance",
      items: [
        {
          title: "Administration",
          icon: IconManualGearbox,
          items: [
            {
              title: "Menu Group",
              url: "/admin/maint/administration/menu-group",
            },
            {
              title: "Menu Access",
              url: "/admin/maint/administration/menu-access",
            },
            {
              title: "Menu Item",
              url: "/admin/maint/administration/menu-item",
            },
            {
              title: "Role",
              url: "/admin/maint/administration/role",
            },
            {
              title: "User Group",
              url: "/admin/maint/administration/user-group",
            },
            {
              title: "User Role",
              url: "/admin/maint/administration/user-role",
            },
            {
              title: "User",
              url: "/admin/maint/administration/user",
            },
            {
              title: "User Access",
              url: "/admin/maint/administration/user-access",
            },
            {
              title: "User Email",
              url: "/admin/maint/administration/user-email",
            },
          ],
        },
        {
          title: "General",
          icon: IconManualGearbox,
          items: [
            {
              title: "Alert Message",
              url: "/admin/maint/general/alert-message",
            },
            {
              title: "Animal Personality",
              url: "/admin/maint/general/animal-personality",
            },
            {
              title: "Country",
              url: "/admin/maint/general/country",
            },
            {
              title: "Disability",
              url: "/admin/maint/general/disability",
            },
            {
              title: "Document Types",
              url: "/admin/maint/general/document-type",
            },
            {
              title: "Organisation",
              url: "/admin/maint/general/organisation",
            },
            {
              title: "Letter Type",
              url: "/admin/maint/general/letter-type",
            },
            {
              title: "Lookup Category",
              url: "/admin/maint/general/lookup-category",
            },
            {
              title: "Permit/Visa",
              url: "/admin/maint/general/permit-visa",
            },
            {
              title: "Postal Code",
              url: "/admin/maint/general/postal-code",
            },
            {
              title: "Province",
              url: "/admin/maint/general/province",
            },
            {
              title: "Recent Activity",
              url: "/admin/maint/general/recent-activity",
            },
            {
              title: "Relationship",
              url: "/admin/maint/general/relationship",
            },
            {
              title: "School",
              url: "/admin/maint/general/school",
            },
            {
              title: "Status",
              url: "/admin/maint/general/status",
            },
            {
              title: "Subject",
              url: "/admin/maint/general/subject",
            },
            {
              title: "Suburb",
              url: "/admin/maint/general/suburb",
            },         
          ],
        },
        {
          title: "Qualification",
          icon: IconManualGearbox,
          items: [
            {
              title: "Institution Structure",
              url: "/admin/maint/qualification/institution-structure",
            },
            {
              title: "Institution Type",
              url: "/admin/maint/qualification/institution-type",
            },
            {
              title: "Institution Status",
              url: "/admin/maint/qualification/institution-status",
            },
            {
              title: "Institution",
              url: "/admin/maint/qualification/institution",
            },
            {
              title: "Faculty/College/Department",
              url: "/admin/maint/qualification/faculty",
            },
            {
              title: "Campus",
              url: "/admin/maint/qualification/campus",
            },
            {
              title: "Entry Year",
              url: "/admin/maint/qualification/entry-year",
            },
            {
              title: "Entry Term/Semester/Trimester",
              url: "/admin/maint/qualification/entry-term",
            },
            {
              title: "Entry Level",
              url: "/admin/maint/qualification/entry-level",
            },
            {
              title: "Access Route",
              url: "/admin/maint/qualification/access-route",
            },
            {
              title: "Career Direction",
              url: "/admin/maint/qualification/career-direction",
            },
            {
              title: "Qualification Type",
              url: "/admin/maint/qualification/programme-type",
            },
            {
              title: "Qualification Duration",
              url: "/admin/maint/qualification/programme-duration",
            },
            {
              title: "Qualification",
              url: "/admin/maint/qualification/programme",
            },
            {
              title: "Qualifier",
              url: "/admin/maint/qualification/programme-qualifier",
            },
            {
              title: "Prerequisites Type",
              url: "/admin/maint/qualification/prerequisites-type",
            },
            {
              title: "Prerequisite Set",
              url: "/admin/maint/qualification/prerequisite-set",
            },
            {
              title: "Prerequisite Group",
              url: "/admin/maint/qualification/prerequisite-group",
            },
            {
              title: "Prerequisite Component",
              url: "/admin/maint/qualification/prerequisite-component",
            },
          ],
        },
        {
          title: "Examination",
          icon: IconManualGearbox,
          items: [
            {
              title: "Exam Centre",
              url: "/admin/maint/examination/exam-centre",
            },
            {
              title: "Exam Type",
              url: "/admin/maint/examination/exam-type",
            },
            {
              title: "Pass Type",
              url: "/admin/maint/examination/pass-type",
            },
            {
              title: "Aggregate Group Allocation",
              url: "/admin/maint/examination/aggregate-group-allocation",
            },
            {
              title: "Applicant Matric Matching",
              url: "/admin/maint/applicant-matric-matching",
            },
            {
              title: "Exam Import Results Matching",
              url: "/admin/maint/exam-import-type",
            },
            {
              title: "Point Group Allocation",
              url: "/admin/maint/examination/point-group-allocation",
            },
            {
              title: "Point Routine Qualification Allocation",
              url: "/admin/maint/examination/point-routine-qualification-allocation",
            },
            {
              title: "Point Routine Subject Allocation",
              url: "/admin/maint/examination/point-routine-subject-allocation",
            },
            {
              title: "Point Routine Group",
              url: "/admin/maint/examination/point-routine-group",
            },
            {
              title: "Point Routine",
              url: "/admin/maint/examination/point-routine",
            },
          ],
        },
      ],
    },
    {
      title: "Processing",
      items: [
        {
          title: "Processing",
          icon: GearIcon,
          items: [
            {
              title: "Application Modification Capture",
              url: "/admin/processing/application-modification-capture",
            },

            {
              title: "Application Change of Mind Capture",
              url: "/admin/processing/application-change-of-mind-capture",
            },
            {
              title: "Applicant Alert Posting",
              url: "/admin/processing/alert-posting",
            },
            {
              title: "Applicant Points & Prerequisites Calculation",
              url: "/admin/processing/points-calculation",
            },
            {
              title: "Process Easy Pay",
              url: "/admin/processing/easy-pay",
            },
            {
              title: "Process MyGate",
              url: "/admin/processing/mygate",
            },
            {
              title: "Process IUQ Downloads",
              url: "/admin/processing/iuq-downloads",
            },
            {
              title: "View Documents Uploaded by Applicants",
              url: "/admin/processing/document-view",
            },
          ],
        },
      ],
    },

    {
      title: "Audits",
      items: [
        {
          title: "Maintenance Audits",
          icon: IconChecklist,
          items: [
            {
              title: "Maintenance Country Audit",
              url: "/admin/audit/maintenance-country-audit",
            },
            {
              title: "Maintenance Province Audit",
              url: "/admin/audit/maintenance-province-audit",
            },
            {
              title: "Maintenance Relationship Audit",
              url: "/admin/audit/maintenance-relationship-audit",
            },
            {
              title: "Maintenance Alert Message Audit",
              url: "/admin/audit/maintenance-alertmessage-audit",
            },
            {
              title: "Maintenance Letter Type Audit",
              url: "/admin/audit/maintenance-lettertype-audit",
            },
            {
              title: "Maintenance Permit/Visa Type Audit",
              url: "/admin/audit/maintenance-permitvisa-audit",
            },
            {
              title: "Maintenance Disability Audit",
              url: "/admin/audit/maintenance-disability-audit",
            },
            {
              title: "Maintenance Recent Activity Audit",
              url: "/admin/audit/maintenance-recentactivity-audit",
            },
            {
              title: "Maintenance Suburb Audit",
              url: "/admin/audit/maintenance-suburb-audit",
            },
            {
              title: "Maintenance Postal Codes Audit",
              url: "/admin/audit/maintenance-postalcode-audit",
            },
            {
              title: "Maintenance Institution Audit",
              url: "/admin/audit/maintenance-institution-audit",
            },
            {
              title: "Maintenance Institution Structure Audit",
              url: "/admin/audit/maintenance-institutionstructure-audit",
            },
            {
              title: "Maintenance Institution Type Audit",
              url: "/admin/audit/maintenance-institutiontype-audit",
            },
            {
              title: "Maintenance Faculty Audit",
              url: "/admin/audit/maintenance-faculty-audit",
            },
            {
              title: "Maintenance Campus Audit",
              url: "/admin/audit/maintenance-campus-audit",
            },
            {
              title: "Maintenance Entry Year Audit",
              url: "/admin/audit/maintenance-entryyear-audit",
            },
            {
              title: "Maintenance Entry Term Audit",
              url: "/admin/audit/maintenance-entryterm-audit",
            },
            {
              title: "Maintenance Entry Level Audit",
              url: "/admin/audit/maintenance-entrylevel-audit",
            },
            {
              title: "Maintenance Programme Type Audit",
              url: "/admin/audit/maintenance-programmetype-audit",
            },
            {
              title: "Maintenance Programme Duration Audit",
              url: "/admin/audit/maintenance-programmeduration-audit",
            },
            {
              title: "Maintenance Programme Qualifier Audit",
              url: "/admin/audit/maintenance-programmequalifier-audit",
            },
            {
              title: "Maintenance Prerequisite Type Audit",
              url: "/admin/audit/maintenance-prerequisitetype-audit",
            },
            {
              title: "Maintenance Transaction Rate Audit",
              url: "/admin/audit/maintenance-transactionrate-audit",
            },
            {
              title: "Maintenance Transaction Type Audit",
              url: "/admin/audit/maintenance-transactiontype-audit",
            },
            {
              title: "Maintenance Menu Group Audit",
              url: "/admin/audit/maintenance-menugroup-audit",
            },
            {
              title: "Maintenance Menu Item Audit",
              url: "/admin/audit/maintenance-menuitem-audit",
            },
            {
              title: "Maintenance Menu Access Audit",
              url: "/admin/audit/maintenance-menuaccess-audit",
            },
            {
              title: "Maintenance Role Audit",
              url: "/admin/audit/maintenance-role-audit",
            },
            {
              title: "Maintenance User Group Audit",
              url: "/admin/audit/maintenance-usergroup-audit",
            },
            {
              title: "Maintenance User Role Audit",
              url: "/admin/audit/maintenance-userrole-audit",
            },
            {
              title: "Maintenance User Email Audit",
              url: "/admin/audit/maintenance-useremail-audit",
            },
            {
              title: "Maintenance User Access Audit",
              url: "/admin/audit/maintenance-useraccess-audit",
            },
          ],
        },
        {
          title: "Applicant Audits",
          icon: IconChecklist,
          items: [
            {
              title: "Applicant Audit",
              url: "/admin/audit/applicant-audit",
            },            
            {
              title: "Applicant Contact Audit",
              url: "/admin/audit/applicant-contact-audit",
            },
            {
              title: "Applicant Address Audit",
              url: "/admin/audit/applicant-address-audit",
            },
            {
              title: "Applicant Email Audit",
              url: "/admin/audit/applicant-email-audit",
            },
            {
              title: "Applicant Telephone Audit",
              url: "/admin/audit/applicant-telephone-audit",
            },
            {
              title: "Applicant Programme Audit",
              url: "/admin/audit/applicant-programme-audit",
            },
            {
              title: "Applicant Yourself Audit",
              url: "/admin/audit/applicant-yourself-audit",
            },
            {
              title: "Applicant Biographical Audit",
              url: "/admin/audit/applicant-biographical-audit",
            },
            {
              title: "Applicant Schooling Audit",
              url: "/admin/audit/applicant-schooling-audit",
            },
            {
              title: "Applicant Post School Audit",
              url: "/admin/audit/applicant-postschool-audit",
            },
            {
              title: "Applicant Exam Detail Audit",
              url: "/admin/audit/applicant-examdetails-audit",
            },
            {
              title: "Applicant Exam Results Audit",
              url: "/admin/audit/applicant-examresults-audit",
            },
            {
              title: "Applicant Next of Kin Audit",
              url: "/admin/audit/applicant-nok-audit",
            },
            {
              title: "Applicant Guardian Audit",
              url: "/admin/audit/applicant-guardian-audit",
            },
            {
              title: "Applicant Documents Audit",
              url: "/admin/audit/applicant-documents-audit",
            },
            {
              title: "Applicant Alerts Audit",
              url: "/admin/audit/applicant-alert-audit",
            },
            {
              title: "Applicant Tracking Audit",
              url: "/admin/audit/applicant-tracking-audit",
            },
            {
              title: "Applicant Finance Audit",
              url: "/admin/audit/applicant-finance-audit",
            }, 
          ],
        },
      ],
    },
    {
      title: "Communication",
      items: [
        {
          title: "Communication",
          icon: IconReportMoney,
          items: [
            {
              title: "Ad Hoc Message Maintenance",
              url: "/admin/maint/communication/adhoc-message",
            },
            {
              title: "Applicant Ad-Hoc Messages & Email Sending",
              url: "/admin/maint/communication/adhoc-correspondence",
            },
            {
              title: "Applicant Messages Sent & Resend",
              url: "/admin/maint/communication/resend-messages",
            },
            {
              title: "Applicant Emails/Letter Sent & Resend",
              url: "/admin/maint/communication/resend-emails",
            },
            {
              title: "Generate Letters",
              url: "/admin/maint/communication/generate-letters",
            },
          ],
        },
      ],
    },
    {
      title: "Finance",
      items: [
        {
          title: "Finance",
          icon: IconReportMoney,
          items: [
            {
              title: "Application Finance Capture",
              url: "/admin/maint/finance/finance-capture",
            },
            {
              title: "Statement Maintenance",
              url: "/admin/maint/finance/statement",
            },
            {
              title: "Transaction Rates Maintenance",
              url: "/admin/maint/finance/transaction-rate",
            },
            {
              title: "Transaction Types Maintenance",
              url: "/admin/maint/finance/transaction-type",
            },
          ],
        },
      ],
    },
    {
      title: "Reports",
      items: [
        {
          title: "Reports",
          icon: IconReport,
          items: [
            {
              title: "Applicant Totals",
              url: "/admin/reports/applicant-totals",
            },
            {
              title: "Applicants per Qualifications",
              url: "/admin/reports/application-per-qualification",
            },
            {
              title: "Applicants Statistics (Gender, Population, Language)",
              url: "/admin/reports/applicants-statistics/gender-pop-lang",
            },
            {
              title: "Applicants Statistics (Gender, Population, Age)",
              url: "/admin/reports/applicants-statistics/gender-pop-age",
            },
            {
              title: "Applicant Statistics per Institution",
              url: "/admin/reports/applicant-statistics-per-institution",
            },
            {
              title: "Applicant Geographic Statistics",
              url: "/admin/reports/applicant-geographic-statistics",
            },
            {
              title: "Applicant / Application Statistics",
              url: "/admin/reports/application-statistics",
            },
            {
              title: "Applicant Summary",
              url: "/admin/reports/applicant-summary",
            },
            {
              title: "Institutions Statistics",
              url: "/admin/reports/institutions-statistics",
            },
            {
              title: "Application Listing",
              url: "/admin/reports/application-listing",
            },
            {
              title: "School Statistics",
              url: "/admin/reports/school-statistics",
            },
          ],
        },
      ],
    },
    {
      title: "Other",
      items: [
        {
          title: "Settings",
          icon: IconSettings,
          items: [
            {
              title: "Profile",
              url: "/settings",
              icon: IconUserCog,
            },
            {
              title: "Change Password",
              url: "/settings/change-password",
              icon: IconUserShield,
            },
            {
              title: "Account",
              url: "/settings/account",
              icon: IconTool,
            },
            {
              title: "Appearance",
              url: "/settings/appearance",
              icon: IconPalette,
            },
            {
              title: "Notifications",
              url: "/settings/notifications",
              icon: IconNotification,
            },
          ],
        },
        {
          title: "Report an Error",
          url: "/report-error",
          icon: BugIcon,
        },
      ],
    },
  ],
};
